var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 17H3.5C3.22386 17 3 16.7761 3 16.5V3.5C3 3.22386 3.22386 3 3.5 3H13.3787C13.5113 3 13.6385 3.05268 13.7322 3.14645L16.8536 6.26777C16.9473 6.36154 17 6.48871 17 6.62132V16.5C17 16.7761 16.7761 17 16.5 17ZM2 3.5C2 2.67157 2.67157 2 3.5 2H13.3787C13.7765 2 14.158 2.15804 14.4393 2.43934L17.5607 5.56066C17.842 5.84197 18 6.2235 18 6.62132V16.5C18 17.3284 17.3284 18 16.5 18H3.5C2.67157 18 2 17.3284 2 16.5V3.5ZM5.5 6C5.22386 6 5 6.22386 5 6.5C5 6.77614 5.22386 7 5.5 7H11.5C11.7761 7 12 6.77614 12 6.5C12 6.22386 11.7761 6 11.5 6H5.5ZM5 10C5 9.72386 5.22386 9.5 5.5 9.5H14.5C14.7761 9.5 15 9.72386 15 10C15 10.2761 14.7761 10.5 14.5 10.5H5.5C5.22386 10.5 5 10.2761 5 10ZM5.5 13C5.22386 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14H13.5C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13H5.5Z",
    fill: "#2867B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.76a14747f1bde6c0b38b1de4746bd761.svg";
export { ForwardRef as ReactComponent };